document.addEventListener('DOMContentLoaded', function () { 
// 飞机飞入动画时长（需与 CSS transition 保持一致，单位：毫秒）
  var PLANE_DURATION = 1500;
  // 页面加载后延迟触发动画，等待图片等资源加载
  var INIT_DELAY = 1000;

  /**
   * 初始化单个 banner 模块的动画
   * @param {HTMLElement} banner - banner 容器元素
   */
  function initBannerAnimation(banner) {
    var planeImg = banner.querySelector('.animation_img');

    // 延迟启动，确保 banner 背景图已渲染
    setTimeout(function () {
      // 触发飞机从左向右飞入
      banner.classList.add('is-plane-animated');

      /**
       * 飞机飞入完成后，启动四颗星星的旋转动画
       */
      function startStarRotation() {
        banner.classList.add('is-stars-animated');
      }

      if (planeImg) {
        // 优先监听 transition 结束事件，确保飞机到位后再旋转星星
        var fallbackTimer = setTimeout(startStarRotation, PLANE_DURATION + 100);
        var onPlaneDone = function (event) {
          if (event.propertyName !== 'transform') return;
          clearTimeout(fallbackTimer);
          planeImg.removeEventListener('transitionend', onPlaneDone);
          startStarRotation();
        };
        planeImg.addEventListener('transitionend', onPlaneDone);
      } else {
        startStarRotation();
      }
    }, INIT_DELAY);
  }

  function lazyLoadAndAnimate() {
    // 模块缓入
    $('.scroll-animation').each(function() {
      var this_move = $(this);
      if (this_move.offset().top < $(window).scrollTop() + $(window).height()*4/5 && !this_move.hasClass('active')) {
        this_move.addClass("active");
      }
    });
  }
  $(window).on('scroll', lazyLoadAndAnimate);


  /**
   * 页面 DOM 就绪后初始化所有 2026 周年 banner
   */
  function init() {
    var banners = document.querySelectorAll('.anniversary-2026-banner');
    if (!banners.length) return;

    banners.forEach(function (banner) {
      initBannerAnimation(banner);
    });
    
    lazyLoadAndAnimate();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
});
